/**
 * Slick carousel base styles — import only from components that render react-slick.
 * Kept out of global index.scss so pages without carousels skip this CSS.
 */
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './slickCarouselTouchTargets.css'
